import React, { Component } from "react";
import FadeIn from "react-fade-in";
import Parser from "html-react-parser";
import offers from "./offers-data";

class OffersList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleHideOverlay = this.handleHideOverlay.bind(this);
    this.handleShowOverlay = this.handleShowOverlay.bind(this);
  }

  handleHideOverlay() {
    this.setState({ showId: null });
  }

  handleShowOverlay(e) {
    const id = e.target.attributes.getNamedItem("data-id").value;
    this.setState({ showId: parseInt(id, 10) });
  }

  render() {
    const { showId } = this.state;

    return (
      <div className="panel-body offers-wrapper">
        <div className="row">
          {offers.map((offer) => (
            <FadeIn key={offer.id} delay={50} transitionDuration={200}>
              <div className="col-xs-12 col-md-6 col-lg-4 col-xl-3 offer-outer">
                <div className="card offer">
                  <div className="card-body">
                    <FadeIn key={offer.id} delay={150} transitionDuration={200}>
                      {/* Overlay */}
                      <div
                        id={offer.overlayId}
                        className={
                          showId === offer.id
                            ? "info-overlay show"
                            : "info-overlay"
                        }
                      >
                        <button
                          className="overlay-close"
                          type="button"
                          id={offer.qoverlayId}
                          onClick={this.handleHideOverlay}
                        >
                          <i className="fa fa-times" aria-hidden="true" />
                        </button>
                        <h4 className="overlay-name">{offer.name}</h4>
                        <div className="overlay-text">
                          {Parser(offer.overlayText)}
                        </div>
                        <a
                          href={offer.overlayOfferLink}
                          target="_blank"
                          title="View Offer"
                          rel="noopener noreferrer"
                          to={offer.overlayOfferLink}
                          id={offer.id}
                          key={offer.id}
                          className="btn btn-secondary-new-link overlay-link"
                        >
                          {offer.overlayLinkName}
                        </a>
                      </div>

                      {/* Offer */}
                      <div className="offer-image">
                        <img src={offer.backgroundImg} alt={offer.imgAlt} />
                      </div>
                      <img
                        src={offer.logo}
                        alt={offer.imgAlt}
                        className="offer-logo"
                      />
                      <div className="offer-about">
                        <h3 className="card-title">{offer.name}</h3>
                        <div className="card-text">
                          <p>{Parser(offer.info)}</p>
                        </div>
                      </div>
                      <button
                        id={offer.id}
                        data-id={offer.id}
                        type="button"
                        key={offer.id}
                        className="btn btn-secondary-new-link see-more-link position-relative"
                        onClick={this.handleShowOverlay}
                      >
                        See More
                      </button>
                    </FadeIn>
                  </div>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    );
  }
}

export default OffersList;
